/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import ModelEditContext from "components/model-selector/context";
import AddModelButton from "components/model-selector/add-model-button";
import ModelSelectorDisplayPanel from "components/model-selector/display/display-panel";

const ModelSelectorDisplay = (props) => {
    
    const AddComponent = props.AddComponent;
    const DisplayComponent = props.DisplayComponent;
    const ctx = useContext(ModelEditContext);
    const {
        setOpen,
        model,
        onChange,
        onRemove,
    } = ctx;
    
    return (
        <Fragment>
            {model && model?.guid ? (
                <Fragment>
                    {DisplayComponent ? (
                        <>
                            <DisplayComponent
                                // this dynamic Component allows you to pass in your own React component as an add button
                                model={model}
                                setOpen={setOpen}
                                onChange={onChange}
                                onRemove={onRemove}
                                onClick={() => setOpen(true)}
                            />
                        </>
                    ) : (
                        <ModelSelectorDisplayPanel />
                    )}
                </Fragment>
            ) : (
                <Fragment>
                    {AddComponent ? (
                        <>
                            <AddComponent
                                // this dynamic Component allows you to pass in your own React component as an add button
                                model={model}
                                setOpen={setOpen}
                                onClick={() => setOpen(true)}
                            />
                        </>
                    ) : (
                        <AddModelButton setOpen={setOpen} />
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default ModelSelectorDisplay;
